export default __webpack_public_path__ + "static/media/check.23c9f8f3.svg";